<script setup lang="ts">
  import { computed } from 'vue';

  import { EnumRoutes } from '@/helpers/enums/routes.enum';
  import { useCartStore } from '@/stores/cart.store';
  const cartStore = useCartStore();
  const cartCount = computed(() => {
    return cartStore.cart?.purchasedItems?.length ?? 0;
  });
</script>

<template>
  <router-link
    :to="{ name: EnumRoutes.financials.cartPage.name }"
    aria-label="cart"
    class="text-none pe-2"
  >
    <div class="position-relative">
      <svg
        width="18"
        height="21"
        viewBox="0 0 18 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 5H14C14 2.2 11.8 0 9 0C6.2 0 4 2.2 4 5H2C0.9 5 0 5.9 0 7V19C0 20.1 0.9 21 2 21H16C17.1 21 18 20.1 18 19V7C18 5.9 17.1 5 16 5ZM9 2C10.7 2 12 3.3 12 5H6C6 3.3 7.3 2 9 2ZM16 19H2V7H16V19ZM9 11C7.3 11 6 9.7 6 8H4C4 10.8 6.2 13 9 13C11.8 13 14 10.8 14 8H12C12 9.7 10.7 11 9 11Z"
          class="fill-icon"
        />
      </svg>
      <div
        v-if="cartCount"
        class="cart-count d-flex align-center justify-center"
      >
        {{ cartCount }}
      </div>
    </div>
  </router-link>
</template>
<style lang="scss">
  .cart-count {
    position: absolute;
    top: -5px;
    right: -10px;
    border-radius: 100%;
    background-color: #05dbf2;
    width: 16px;
    height: 16px;
    font-size: 12px;
    color: white;
  }
  .fill-icon {
    fill: $black-600;
  }
</style>
